import { put, select, takeEvery } from "redux-saga/effects"
import {
  axiosPut,
  delPointsAxiosWithParams,
  getPointsAxiosWithParams,
  postPointsAxios,
  putPointsAxios,
} from "helpers/api_helper"
import {
  ADD_TRIVIA_CHALLENGE,
  DELETE_TRIVIA_CHALLENGE,
  GET_TRIVIA_CHALLENGE,
  GET_TRIVIA_CHALLENGE_LIST,
  GET_TRIVIA_REPLY,
  UPDATE_TRIVIA_CHALLENGE,
  UPDATE_TRIVIA_LIST_ITEM,
  UPDATE_TRIVIA_ORDER,
} from "./actionTypes"
import {
  addTriviaChallengeFailed,
  addTriviaChallengeSuccess,
  deleteTriviaChallengeFailed,
  deleteTriviaChallengeSuccess,
  getTriviaChallengeFailed,
  getTriviaChallengeListFailed,
  getTriviaChallengeListSuccess,
  getTriviaChallengeSuccess,
  getTriviaReplyFailed,
  getTriviaReplySuccess,
  hideDeleteTriviaModal,
  updateTriviaChallengeFailed,
  updateTriviaChallengeSuccess,
  updateTriviaListItemFailed,
  updateTriviaListItemSuccess,
  updateTriviaOrderFailed,
  updateTriviaOrderSuccess,
} from "./actions"
import {
  putMenuItemSuccess,
  setIsOutdated,
  setSelectedFeature,
  showSavingModal,
  hideSavingModal,
} from "../actions"

function* addTriviaChallenge({ payload: params }) {
  try {
    yield put(showSavingModal())
    const questionResponse = yield postPointsAxios("/trivia-question", {
      questions: params.questions,
    })
    const triviaResponse = yield postPointsAxios("/trivia", {
      ...params.trivia,
      questions: questionResponse.map(question => question.id),
    })
    if (params.trivia.menu_feature) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: triviaResponse.id,
        menu_item_id: triviaResponse.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setIsOutdated(true))
      yield put(setSelectedFeature(menuItem))
    } else {
      const responseList = yield getPointsAxiosWithParams("/trivia", {
        params: {
          event_id: params.trivia.event_id,
          menu_item_id: params.trivia.menu_item_id,
        },
      })
      yield put(getTriviaChallengeListSuccess(responseList))
    }
    yield put(addTriviaChallengeSuccess(triviaResponse))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addTriviaChallengeFailed(error))
  }
}

function* getTriviaChallenge({ payload: params }) {
  try {
    const response = yield getPointsAxiosWithParams(`/trivia/${params}`)
    const destroyed = yield select(state => state.TriviaChallenge.destroyed)
    if (!destroyed) {
      yield put(getTriviaChallengeSuccess(response))
    }
  } catch (error) {
    yield put(getTriviaChallengeFailed(error))
  }
}

function* updateTriviaChallenge({ payload: params }) {
  try {
    yield put(showSavingModal())
    const questionIds = []
    for (let question of params.updatedQuestions) {
      const response = yield putPointsAxios(
        `/trivia-question/${question.id}`,
        question
      )
      questionIds.push(response.id)
    }
    if (params.newQuestions.length > 0) {
      const newQuestionsResponse = yield postPointsAxios("/trivia-question", {
        questions: params.newQuestions,
      })
      newQuestionsResponse.forEach(item => {
        questionIds.push(item.id)
      })
    }
    const triviaResponse = yield putPointsAxios(
      `/trivia/${params.trivia.id}`,
      {
        ...params.trivia,
        questions: questionIds,
      },
      {
        params: { menu_item_id: params.trivia.menu_item_id },
      }
    )
    if (params.trivia.menu_feature) {
      const updatedTrivia = yield getPointsAxiosWithParams(
        `/trivia/${params.trivia.id}`
      )
      yield put(getTriviaChallengeSuccess(updatedTrivia))
    }
    yield put(updateTriviaChallengeSuccess(triviaResponse))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateTriviaChallengeFailed(error))
  }
}

function* getTriviaChallengeList({ payload: params }) {
  try {
    const response = yield getPointsAxiosWithParams("/trivia", { params })
    const destroyed = yield select(state => state.TriviaChallenge.listDestroyed)
    if (!destroyed) {
      yield put(getTriviaChallengeListSuccess(response))
    }
  } catch (error) {
    yield put(getTriviaChallengeListFailed(error))
  }
}

function* deleteTriviaChallenge({ payload: params }) {
  try {
    const response = yield delPointsAxiosWithParams(`/trivia/${params.id}`, {
      menu_item_id: params.menu_item_id,
    })
    yield put(deleteTriviaChallengeSuccess(response))
    yield put(hideDeleteTriviaModal())
  } catch (error) {
    yield put(deleteTriviaChallengeFailed(error))
  }
}

function* updateTriviaListItem({ payload: params }) {
  try {
    const response = yield putPointsAxios(`/trivia/${params.id}`, params, {
      params: { menu_item_id: params.menu_item_id },
    })
    yield put(setIsOutdated(true))
    yield put(updateTriviaListItemSuccess(response))
  } catch (error) {
    yield put(updateTriviaListItemFailed(error))
  }
}

function* updateTriviaOrder({ payload: params }) {
  try {
    const response = yield putPointsAxios(`/trivia/${params.id}`, params, {
      params: { menu_item_id: params.menu_item_id },
    })
    yield put(updateTriviaOrderSuccess(response))
  } catch (error) {
    yield put(updateTriviaOrderFailed(error))
  }
}

function* getTriviaReply({ payload: params }) {
  try {
    const response = yield getPointsAxiosWithParams(
      `/trivia/${params?.id}/reply`
    )
    yield put(getTriviaReplySuccess(response))
  } catch (error) {
    yield put(getTriviaReplyFailed(error))
  }
}

function* triviaChallengeSaga() {
  yield takeEvery(ADD_TRIVIA_CHALLENGE, addTriviaChallenge)
  yield takeEvery(GET_TRIVIA_CHALLENGE, getTriviaChallenge)
  yield takeEvery(UPDATE_TRIVIA_CHALLENGE, updateTriviaChallenge)
  yield takeEvery(GET_TRIVIA_CHALLENGE_LIST, getTriviaChallengeList)
  yield takeEvery(DELETE_TRIVIA_CHALLENGE, deleteTriviaChallenge)
  yield takeEvery(UPDATE_TRIVIA_LIST_ITEM, updateTriviaListItem)
  yield takeEvery(UPDATE_TRIVIA_ORDER, updateTriviaOrder)
  yield takeEvery(GET_TRIVIA_REPLY, getTriviaReply)
}

export default triviaChallengeSaga
